import { useEffect, useState } from "react"

//styling
import myStyles from "../../../styles/assessments/AssessmentScheduleForm.module.css"

//PrimeReacy
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"

//Formik
import { useField } from "formik"
import { getCronTimeUtc } from "./scheduleHelpers"
import { DateTime } from "luxon"

export default function AssessmentScheduleDaily({
  cronFieldName,
  startDateFieldName,
  timeValue,
  refreshCronStatement,
  disabled,
}) {
  const [field, , helpers] = useField(cronFieldName)
  const [, , startDateHelpers] = useField(startDateFieldName)

  const [isXDays, setIsXDays] = useState(true)
  const [days, setDays] = useState(1)

  useEffect(() => {
    if (field.value !== "") {
      var existingCron = field.value?.split(" ")

      if (existingCron.length === 5) {
        //Check if the settings should be updated, if not: Keep defaults
        if (existingCron[4] === "MON-FRI") {
          setIsXDays(false)
        } else if (existingCron[4].includes("*/")) {
          setIsXDays(true)
          setDays(+existingCron[4].replace("*/", ""))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let timeValues = getCronTimeUtc(timeValue)

    //Default cron is week days
    let newCron = `${timeValues} * * MON-FRI`
    if (isXDays) {
      newCron = `${timeValues} * * */${days}`
    }

    helpers.setValue(newCron)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isXDays, days, refreshCronStatement])

  const QuickOptionsFromToday = ({ days, disabled }) => {
    return (
      <div
        className={`${myStyles.periodOption} ${
          disabled
            ? myStyles.periodOptionButtonDisable
            : myStyles.periodOptionButton
        } tt-periodOptionButton`}
        onClick={() => {
          if (!disabled) {
            const newStartDate = DateTime.now()
            startDateHelpers.setValue(newStartDate.toJSDate())

            setIsXDays(true)
            setDays(days)
          }
        }}
      >
        {`Every ${days} days from today`}
      </div>
    )
  }

  return (
    <div className={myStyles.periodOptionContainer}>
      <QuickOptionsFromToday days={30} disabled={disabled} />
      <QuickOptionsFromToday days={60} disabled={disabled} />
      <QuickOptionsFromToday days={90} disabled={disabled} />
      <div className={myStyles.periodOption}>
        <Checkbox
          checked={isXDays}
          onChange={(e) => {
            setIsXDays(e.checked)
          }}
          disabled={disabled}
        />{" "}
        Every{" "}
        <Dropdown
          value={days}
          options={[1, 2, 3, 4, 5, 6, 7, 30, 60, 90]}
          onChange={(e) => {
            setIsXDays(true)
            setDays(e.value)
          }}
          className={myStyles.periodDropdown}
          disabled={disabled}
        />{" "}
        Day(s)
      </div>
      <div className={myStyles.periodOption}>
        <Checkbox
          checked={!isXDays}
          onChange={(e) => {
            setIsXDays(!e.checked)
          }}
          disabled={disabled}
        />{" "}
        Every week day
      </div>
    </div>
  )
}
